import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { curry } from '../utils/func';
import { capitalize } from '../utils/strings';
import { IGNORE_VALIDATE, WITH_OUT_DISPATCH } from './types';
import List from './List';
import Form from './Form';
var types = {
  form: Form,
  list: List
};
export default curry(function (options, Origin) {
  var _class, _temp;

  var _ref = options || {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'list' : _ref$type,
      _ref$key = _ref.key,
      key = _ref$key === void 0 ? 'value' : _ref$key,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 0 : _ref$limit,
      _ref$bindProps = _ref.bindProps,
      bindProps = _ref$bindProps === void 0 ? [] : _ref$bindProps,
      ignoreUndefined = _ref.ignoreUndefined,
      _ref$pure = _ref.pure,
      pure = _ref$pure === void 0 ? true : _ref$pure;

  var Datum = types[type];
  var Component = pure ? React.PureComponent : React.Component;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper2(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.datum = void 0;
      _this.prevValues = void 0;
      var datum = props.datum,
          onChange = props.onChange,
          initValidate = props.initValidate;

      if (datum instanceof Datum) {
        _this.datum = datum;
      } else {
        var ops = bindProps.reduce(function (o, k) {
          o[k] = props[k];
          return o;
        }, {
          limit: limit,
          initValidate: initValidate
        });

        if (key in props) {
          ops[key] = props[key];
        }

        if ("default".concat(capitalize(key)) in props) {
          ops["default".concat(capitalize(key))] = props["default".concat(capitalize(key))];
        }

        _this.datum = new Datum(Object.assign(ops, datum));
      }

      if (onChange) {
        _this.datum.onChange = onChange;
      }

      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.datum.setLock(false);
        this.prevValues = this.props[key];
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // update datum.onchange
        this.datum.setLock(false);

        if (prevProps.onChange !== this.props.onChange) {
          this.datum.onChange = this.props.onChange;
        }
      }
    }, {
      key: "setValue",
      value: function setValue(t) {
        var values = this.props[key];
        if (ignoreUndefined && values === undefined) return;
        this.datum.setValue(values, t);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            onDatumBind = _this$props.onDatumBind,
            props = _objectWithoutProperties(_this$props, ["onDatumBind"]);

        if (onDatumBind) onDatumBind(this.datum);

        if (bindProps.includes('disabled')) {
          this.datum.setDisabled(props.disabled);
        }

        var values = this.props[key];

        if (type === 'form' && values !== this.prevValues) {
          this.setValue(this.props.initValidate ? undefined : IGNORE_VALIDATE);
          this.datum.setLock(true);
          this.prevValues = values;
        }

        if (type === 'list') this.setValue(WITH_OUT_DISPATCH); // delete props[key]

        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            datum: this.datum
          }))
        );
      }
    }]);

    return _class;
  }(Component), _class.defaultProps = {
    initValidate: false
  }, _temp;
});